import React, { useEffect, useState } from "react";
import { backend, API_URL } from "../../../config";
import { Link } from "react-router-dom";
import {
  Container,
  Button,
  Modal,
  Typography,
  CircularProgress,
  InputAdornment,
  IconButton,
  Stack,
  Grid,
  InputLabel,
  Autocomplete,
  TextField,
  debounce,
} from "@mui/material";

import { RestartAlt as RestartAltIncon } from "@mui/icons-material";

import { makeStyles } from "@mui/styles";

import ProductForm from "../components/Forms/ProductForm";
import ProductKeyForm from "../components/Forms/ProductKeyForm";
import ProductMoreForm from "../components/Forms/ProductMoreForm";

const useStyles = makeStyles((theme) => ({
  modal: {
    position: "absolute",
    width: 400,
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.2)",
    borderRadius: ".3rem",
    boxShadow: theme.shadows[5],
    padding: "1rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
}));

const ProductAdd = (props) => {
  const classes = useStyles();
  const productId = props.match.params.id;

  const cDate = new Date();
  const cDateOffset = new Date(
    cDate.getTime() - cDate.getTimezoneOffset() * 60000,
  );

  const yearVal = cDateOffset.getFullYear();

  let monthVal = (1 + cDateOffset.getMonth()).toString();
  monthVal = monthVal.length > 1 ? monthVal : "0" + monthVal;

  let dayVal = cDateOffset.getDate().toString();
  dayVal = dayVal.length > 1 ? dayVal : "0" + dayVal;

  const [confirmModal, setConfirmModal] = useState(false);
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [product, setProduct] = useState({
    acceptable_substitutions: [],
    acceptable_substitutions_detail: [],
    active: true,
    case_price: 0,
    api_description: "",
    api_managed: false,
    api_manager: "",
    unit_price: 0,
    average_case_weight: 0,
    average_unit_weight: 0,
    bin: "",
    bin_normalized: "",
    catch_weight: false,
    api_category: "",
    api_department: "",
    api_department_id: "",
    display_units_per_case_on_invoice: false,
    api_group: "",
    api_group_id: "",
    item_code: {
      item_code: "",
      master_upc: null,
      name: "",
      url: "",
    },
    itemcode_set: [],
    items_per_case: 0,
    lot_tracked: false,
    name: "",
    order_items: [],
    order_items_from_original: [],
    override: [],
    pk: null,
    price_as_of: `${monthVal}/${dayVal}/${yearVal}`,
    qb_mapping: "",
    qb_site_mapping: "",
    size: "",
    snapshots: [],
    surchargeitem_set: [],
    tax_default: false,
    unit_type: "Unit",
    units_per_case: 0,
    upc: "",
    url: "",
    use_override: false,
    volume: "",
    volume_level: 0,
    volume_price: 0,
    warehouse: null,
    warehouse_id: null,
    category: null,
    weight: "",
    weight_type: "",
    fees: [],
    margins: [],
    surcharges: [],
    unit_type_unit: false,
    unit_type_case: false,
    item_type: "",
    price_per_unit: 0,
    price_per_lb: 0,
    average_unit_price: 0,
    average_case_price: 0,
    fixed_random_weight: false,
    overridden_fields: [],
    overridden_fields_original_values: {},
    on_order: "",
    stock_level: 0,
    surcharge_upc1: "",
    surcharge_upc2: "",
    surcharge_upc1_detail: null,
    surcharge_upc2_detail: null,
    custom_image: null,
    price_links: [],
    price_links_detail: [],
    par_stock: "",
    item_searchable: false,
    reorder_quantity: "",
  });
  const [productLoaded, setProductLoaded] = useState(false);

  const [warehouses, setWarehouses] = useState([]);
  const [flattenedCategories, setFlattenedCategories] = useState([]);
  const [loadingFlag, setLoadingFlag] = useState(false);
  const [finishedFlag, setFinishedFlag] = useState(false);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [overriddenFields, setOverriddenFields] = useState([]);
  const [productModal, setProductModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [productInputValue, setProductInputValue] = useState("");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dirtyFlag, setDirtyFlag] = useState(false);
  const [productASOptions, setProductASOptions] = useState([]);
  const [productASInputValue, setProductASInputValue] = useState("");
  const [surchargeUpc1Options, setSurchargeUpc1Options] = useState([]);
  const [surchargeUpc1InputValue, setSurchargeUpc1InputValue] = useState("");
  const [isSurchargeUpc1Loading, setIsSurchargeUpc1Loading] = useState(false);
  const [surchargeUpc2Options, setSurchargeUpc2Options] = useState([]);
  const [surchargeUpc2InputValue, setSurchargeUpc2InputValue] = useState("");
  const [isSurchargeUpc2Loading, setIsSurchargeUpc2Loading] = useState(false);

  const handleChange = (e, v) => {
    const { checked, name, value } = e.target;

    setProduct((prevState) => {
      let productObj = { ...prevState };
      let calcAverageUnitPrice = 0;
      let calcAverageCasePrice = 0;

      if (
        !v &&
        typeof value === "string" &&
        value.includes("_reset_overridden")
      ) {
        productObj = {
          ...productObj,
          [name]: productObj.of_default_values[name] || productObj[name],
        };
      } else {
        switch (name) {
          case "catch_weight":
          case "tax_default":
          case "fixed_random_weight":
          case "active":
          case "unit_type_unit":
          case "unit_type_case":
          case "display_units_per_case_on_invoice":
          case "lot_tracked":
          case "enable_price_links":
          case "item_searchable":
            productObj = { ...productObj, [name]: checked };

            if (["unit_type_unit", "unit_type_case"].includes(name)) {
              const unitType =
                productObj.unit_type_unit && productObj.unit_type_case
                  ? "Unit / Case"
                  : productObj.unit_type_case
                    ? "Case"
                    : "Unit";

              productObj = {
                ...productObj,
                [name]: checked,
                unit_type: unitType,
              };
            }

            // todo: define item type when switching catch_weight and fixed weight through old fields
            break;
          case "price_links":
            handleChangeItemReference(false, v);
            break;
          case "item_code":
            productObj = {
              ...productObj,
              [name]: {
                item_code: value,
                master_upc: productObj[name].master_upc,
              },
            };
            break;
          case "acceptable_substitutions_detail":
          case "warehouse":
          case "category":
            productObj = { ...productObj, [name]: v };

            if (name === "acceptable_substitutions_detail") {
              setProductASInputValue("");
              setProductASOptions(v);
            }
            break;
          case "surcharge_upc1_detail":
            productObj = {
              ...productObj,
              surcharge_upc1_detail: v,
              surcharge_upc1: v?.upc || "",
            };
            setSurchargeUpc1InputValue("");
            break;
          case "surcharge_upc2_detail":
            productObj = {
              ...productObj,
              surcharge_upc2_detail: v,
              surcharge_upc2: v?.upc || "",
            };
            setSurchargeUpc2InputValue("");
            break;
          case "unit_type":
            const isUnit = ["Unit", "Unit / Case"].includes(value);
            const isCase = ["Case", "Unit / Case"].includes(value);

            productObj = {
              ...productObj,
              [name]: value,
              unit_type_unit: isUnit,
              unit_type_case: isCase,
            };
            break;
          case "case_price":
          case "unit_price":
          case "units_per_case":
            const calcPricePerUnitCase =
              +value === 0
                ? 0
                : name === "case_price"
                  ? value / productObj["units_per_case"]
                  : name === "units_per_case"
                    ? productObj["case_price"] / value
                    : +productObj.price_per_unit;
            calcAverageUnitPrice = value * +productObj["average_unit_weight"];
            calcAverageCasePrice = value * +productObj["average_case_weight"];

            productObj = {
              ...productObj,
              [name]: value !== "" ? +value : value,
              price_per_unit: calcPricePerUnitCase,
              average_unit_price: calcAverageUnitPrice,
              average_case_price: calcAverageCasePrice,
            };
            break;
          case "average_unit_weight":
          case "average_case_weight":
            calcAverageUnitPrice =
              name === "average_unit_weight"
                ? productObj["unit_price"] * value
                : +productObj["average_unit_price"];
            calcAverageCasePrice =
              name === "average_case_weight"
                ? productObj["case_price"] * value
                : +productObj["average_case_price"];

            productObj = {
              ...productObj,
              [name]: value,
              average_unit_price: calcAverageUnitPrice.toFixed(2),
              average_case_price: calcAverageCasePrice.toFixed(2),
            };
            break;
          case "item_type_non_weighted":
          case "item_type_catch_weight":
          case "item_type_fixed_random_weight":
            const itemType = name.replace("item_type_", "");
            productObj = {
              ...productObj,
              item_type: itemType,
              weight_type:
                itemType === "catch_weight"
                  ? "r/w"
                  : itemType === "fixed_random_weight"
                    ? "fix"
                    : "",
            };
            break;
          default:
            productObj = {
              ...productObj,
              [name]: value,
            };
        }
      }

      return productObj;
    });
  };

  const handleChangeProductASInput = debounce((e) => {
    const { value } = e.target;

    if (value?.length) {
      setProductASOptions([...product.acceptable_substitutions_detail]);
      setProductASInputValue(value);
    }
  }, 300);

  const handleChangeSurchargeUpc1Input = debounce((e) => {
    const { value } = e.target;
    if (value?.length) {
      setSurchargeUpc1InputValue(value);
    }
  }, 300);

  const handleChangeSurchargeUpc2Input = debounce((e) => {
    const { value } = e.target;
    if (value?.length) {
      setSurchargeUpc2InputValue(value);
    }
  }, 300);

  const handleCdnUpload = async (blob) => {
    if (!productId) return;
    const formData = new FormData();
    const timestamp = Math.floor(Date.now() / 1000);
    formData.append(
      "custom_image",
      blob,
      `product_${productId}_${timestamp}.jpg`,
    );
    await backend
      .patch(`${API_URL}productedit/${productId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(({ data }) => {
        setProduct((prev) => ({ ...prev, custom_image: data.custom_image }));
      });
  };

  // NOTE: sending custom_image: null assumes the backend serializer accepts null/blank
  // to clear the R2 file. Adjust to an empty string or a dedicated endpoint if needed.
  const handleCdnRemove = async () => {
    if (!productId) return;
    await backend
      .patch(`${API_URL}productedit/${productId}`, { custom_image: null })
      .then(() => {
        setProduct((prev) => ({ ...prev, custom_image: null }));
      });
  };

  const handleBack = () => {
    props.history.push("/inventory");
  };

  const handleChangeItemReference = (
    add = false,
    refProduct = selectedProduct,
  ) => {
    if (!refProduct) return;

    setProduct((prevState) => {
      let productObj = { ...prevState };
      let priceLinksMap = [...productObj.price_links];
      let priceLinksDetailMap = [...productObj.price_links_detail];

      if (add) {
        priceLinksMap.push(refProduct.upc);
        priceLinksDetailMap.push({ ...refProduct });
      } else {
        priceLinksMap = priceLinksMap.filter((item) => item !== refProduct.upc);
        priceLinksDetailMap = priceLinksDetailMap.filter(
          (item) => item.upc !== refProduct.upc,
        );
      }

      productObj = {
        ...productObj,
        price_links: priceLinksMap,
        price_links_detail: priceLinksDetailMap,
      };

      return productObj;
    });

    setDirtyFlag(true);

    if (add) {
      handleCloseProductModal();
    }
  };

  const handleChangeProductInput = debounce((e) => {
    const { value } = e.target;
    setProductOptions([]);
    setProductInputValue(value);
  }, 300);

  const handleCloseProductModal = () => {
    setProductOptions([]);
    setIsLoading(false);
    setProductInputValue("");
    setSelectedProduct(null);
    setProductModal(false);
  };

  const toggleConfirmModal = () => setConfirmModal(!confirmModal);

  const confirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to {!isNaN(productId) ? " update " : " add "}
          the product <b>{product.api_description || product.name}</b>
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>
              {!isNaN(productId) ? " Updating product " : " Adding product "}
            </div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while
              {!isNaN(productId) ? " updating " : " saving "}the product
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveErrorConfirm()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The product has been{!isNaN(productId) ? " updated " : " added "}
          successfully
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleDeleteConfirmModal = () =>
    setDeleteConfirmModal(!deleteConfirmModal);

  const deleteConfirmModalContent = (
    <div className={classes.modal}>
      {!loadingFlag && !finishedFlag ? (
        <>
          Are you sure you want to delete the product
          <b> {product.api_description || product.name}</b>
          <br />
          <br />
          <div align="right">
            <Button onClick={() => toggleDeleteConfirmModal()}>Cancel</Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendDeleteRequest()}
            >
              Confirm
            </Button>
          </div>
        </>
      ) : loadingFlag ? (
        <>
          <div align="center">
            <CircularProgress />
            <div>Deleting product</div>
          </div>
          {errorInfo.error ? (
            <>
              <br />
              <br />
              There was an error while deleting the product
              <br />
              <br />
              <span
                style={{
                  color: "red",
                  wordBreak: "break-word",
                  maxHeight: 160,
                  overflow: "hidden",
                  display: "inline-block",
                }}
              >
                <b>Error:</b>
                <br />
                {typeof errorInfo.message === "object" ? (
                  <>
                    <ul>
                      {Object.keys(errorInfo.message).map((key) => (
                        <li key={key}>
                          <b>{key}:</b>
                          {` ${errorInfo.message[key]}`}
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  errorInfo.message
                )}
              </span>
              <div align="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => resolveErrorDelete()}
                >
                  Continue
                </Button>
              </div>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          The product has been deleted successfully
          <br />
          <br />
          <div align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => resolveRequest()}
            >
              Close
            </Button>
          </div>
        </>
      )}
    </div>
  );

  const toggleProductModal = () => setProductModal(!productModal);

  const productModalContent = (
    <div className={classes.modal}>
      <Grid container spacing={2}>
        <Grid item xs={12}></Grid>
        <Grid item xs={12}>
          <InputLabel shrink id="productLabel">
            Product
          </InputLabel>
          <Autocomplete
            fullWidth
            disablePortal
            size="small"
            name="product_id"
            options={productOptions}
            getOptionLabel={(option) =>
              `${option.name} | (${option.upc}) #${
                option.item_code.item_code || ""
              }#`
            }
            isOptionEqualToValue={(option, value) => option.upc === value.upc}
            filterOptions={(options) => options}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                variant="standard"
                helperText="Use this field to search products"
              />
            )}
            renderOption={(props, option) => (
              <li {...props}>
                {`${option.name} | (${option.upc}) #${
                  option.item_code.item_code || ""
                }# Stock: ${option.stock_level || 0} `}
                {["Unit", "Unit / Case"].includes(option.unit_type)
                  ? `Unit: ${option.display_unit_price} `
                  : ""}
                {["Case", "Unit / Case"].includes(option.unit_type)
                  ? `Case: ${option.display_case_price}`
                  : ""}
              </li>
            )}
            getOptionDisabled={(option) =>
              Boolean(product.price_links.includes(option.upc))
            }
            loading={isLoading}
            noOptionsText={
              productInputValue.length < 3
                ? "Please enter at least 3 characters to search"
                : "No options"
            }
            onChange={(e, value) => setSelectedProduct(value)}
            onInputChange={handleChangeProductInput}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <div align="right">
            <Button
              onClick={handleCloseProductModal}
              className={classes.button}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleChangeItemReference(true)}
              className={classes.button}
            >
              Confirm
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const sendRequest = async () => {
    setLoadingFlag(true);

    const productASMap = product.acceptable_substitutions_detail.map(
      (item) => item.upc,
    );

    const productPLMap = product?.price_links_detail?.map((item) => item.upc);

    const productObjPayload = {
      active: product.active,
      acceptable_substitutions: productASMap,
      average_unit_weight: product.average_unit_weight,
      average_case_weight: product.average_case_weight,
      bin: product.bin,
      bin_normalized: product.bin_normalized,
      case_price: product.case_price === 0 ? null : product.case_price,
      category_id: product.category ? product?.category?.id || null : null,
      api_department: product.api_department,
      api_department_id: product.api_department_id,
      display_units_per_case_on_invoice:
        product.display_units_per_case_on_invoice,
      enable_price_links: product.enable_price_links,
      api_group: product.api_group,
      api_group_id: product.api_group_id,
      item_code_id: product.item_code.item_code,
      item_searchable: product.item_searchable,
      items_per_case: product.items_per_case,
      lot_tracked: product.lot_tracked,
      name: product.name,
      on_order: product.on_order,
      par_stock: product.par_stock,
      price_as_of: product.price_as_of,
      price_links: productPLMap,
      qb_mapping: product.qb_mapping,
      qb_site_mapping: product.qb_site_mapping,
      reorder_quantity: product.reorder_quantity,
      size: product.size,
      stock_level: product.stock_level,
      surcharge_upc1: +product.surcharge_upc1 ? +product.surcharge_upc1 : null,
      surcharge_upc2: +product.surcharge_upc2 ? +product.surcharge_upc2 : null,
      tax_default: product.tax_default,
      unit_price: product.unit_price === 0 ? null : product.unit_price,
      unit_type: product.unit_type,
      units_per_case: product.units_per_case,
      upc: product.upc,
      url: product.url,
      use_override: product.use_override,
      volume: product.volume,
      volume_level: product.volume_level,
      volume_price: product.volume_price,
      warehouse_id: product.warehouse.id,
      weight: product.weight,
      weight_type: product.weight_type,
    };

    if (!productId) {
      delete productObjPayload.upc;
    }

    if (product.unit_price === 0) {
      delete productObjPayload.unit_price;
    }

    if (product.case_price === 0) {
      delete productObjPayload.case_price;
    }

    if (productId && !isNaN(productId)) {
      await backend
        .patch(`${API_URL}productedit/${productId}`, productObjPayload)
        .then(() => {
          setLoadingFlag(false);
          setFinishedFlag(true);
          setDirtyFlag(false);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.hasOwnProperty("message")
                    ? errorData.detail
                    : errorData
                : error.message,
          });
        });
    } else {
      await backend
        .post(`${API_URL}productedit/`, productObjPayload)
        .then(({ data }) => {
          setLoadingFlag(false);
          setFinishedFlag(true);
          setDirtyFlag(false);

          props.history.push(`/product/${data.upc}/fees`);
        })
        .catch((error) => {
          console.log(error);
          const errorData = error.response.data;

          setErrorInfo({
            error: true,
            message:
              typeof errorData === "object"
                ? errorData.hasOwnProperty("message")
                  ? errorData.message
                  : errorData.hasOwnProperty("message")
                    ? errorData.detail
                    : errorData
                : error.message,
          });
        });
    }
  };

  const sendDeleteRequest = async () => {
    setLoadingFlag(true);

    await backend
      .delete(`${API_URL}products/${productId}`)
      .then(() => {
        setLoadingFlag(false);
        setFinishedFlag(true);
        setDirtyFlag(false);
      })
      .catch((error) => {
        console.log(error);
        const errorData = error.response.data;

        setErrorInfo({
          error: true,
          message:
            typeof errorData === "object"
              ? errorData.hasOwnProperty("message")
                ? errorData.message
                : errorData.hasOwnProperty("message")
                  ? errorData.detail
                  : errorData
              : error.message,
        });
      });
  };

  const resolveError = () => {
    setLoadingFlag(false);
    setFinishedFlag(false);
    setErrorInfo({ error: false, message: "" });
  };

  const resolveErrorConfirm = () => {
    toggleConfirmModal();
    resolveError();
  };

  const resolveErrorDelete = () => {
    toggleDeleteConfirmModal();
    resolveError();
  };

  const resolveRequest = () => {
    props.history.push("/inventory");
  };

  const overriddenEndorment = (field, product) => {
    if (
      !product.api_managed ||
      !overriddenFields.includes(field) ||
      !product.of_default_values.hasOwnProperty(field)
    )
      return <></>;

    const defaultVal =
      field === "item_code"
        ? product.of_default_values.item_code.item_code
        : product.of_default_values[field];
    const currentVal =
      field === "item_code" ? product.item_code.item_code : product[field];

    if (defaultVal !== currentVal) {
      return (
        <InputAdornment position="end">
          <IconButton
            aria-label="reset overridden value"
            onClick={() =>
              handleChange({
                target: { name: field, value: "_reset_overridden" },
              })
            }
          >
            <RestartAltIncon />
          </IconButton>
        </InputAdornment>
      );
    }

    return <></>;
  };

  const overriddenStyle = (field, product) => {
    if (
      !product.api_managed ||
      !overriddenFields.includes(field) ||
      !product.of_default_values.hasOwnProperty(field)
    )
      return "inherit";

    const defaultVal =
      field === "item_code"
        ? product.of_default_values.item_code.item_code
        : product.of_default_values[field];
    const currentVal =
      field === "item_code" ? product.item_code.item_code : product[field];

    if (defaultVal !== currentVal) return "lightblue";

    if (
      product.overridden_fields_original_values.hasOwnProperty(field) ||
      (field === "item_code" &&
        product.overridden_fields_original_values.hasOwnProperty(
          "item_code_id",
        ))
    )
      return "lightblue";

    return "inherit";
  };

  useEffect(() => {
    const flattenCategories = (categories, depth = 0, parentPath = "") => {
      let flattened = [];

      categories.forEach((category) => {
        const fullPath = parentPath
          ? `${parentPath} > ${category.name}`
          : category.name;

        flattened.push({
          id: category.id,
          name: category.name,
          depth,
          fullPath,
          parent_id: category.parent_id || null,
          active: category.active,
        });

        if (category.children && category.children.length > 0) {
          flattened = [
            ...flattened,
            ...flattenCategories(category.children, depth + 1, fullPath),
          ];
        }
      });

      return flattened;
    };

    const getOverriddenFields = () => {
      setOverriddenFields([
        "weight_type",
        "price_as_of",
        "item_code",
        "units_per_case",
        "items_per_case",
        "unit_type",
        "bin",
        "api_department_id",
        "api_department",
        "api_group_id",
        "api_group",
        "stock_level",
        "on_order",
        "size",
        "weight",
        "volume",
        "volume_price",
        "volume_level",
        "average_unit_weight",
        "average_case_weight",
        "surcharge_upc1",
        "surcharge_upc2",
        "tax_default",
        "unit_price",
        "case_price",
        "url",
      ]);
    };

    const getWarehouses = async () => {
      await backend.get(`${API_URL}warehouses?no_page=1`).then(({ data }) => {
        const dataMap = data.map((item) => ({ id: item.id, name: item.name }));
        setWarehouses(dataMap);
      });
    };

    const getCategories = async () => {
      await backend
        .get(`${API_URL}productcategories?no_page=1`)
        .then(({ data }) => {
          const flattened = flattenCategories(data);
          setFlattenedCategories(flattened);
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        });
    };

    getOverriddenFields();
    getWarehouses();
    getCategories();
  }, []);

  useEffect(() => {
    const getProduct = async () => {
      await backend
        .get(`${API_URL}productedit/${productId}?substitution_detail=true`)
        .then(async ({ data }) => {
          const calcAverageUnitPrice =
            data.unit_price * data.average_unit_weight;
          const calcAverageCasePrice =
            data.case_price * data.average_case_weight;

          const productObj = {
            ...data,
            fees: data.fees || [],
            margins: [],
            surcharges: [],
            unit_type_unit:
              data.unit_type === "Unit" || data.unit_type === "Unit / Case"
                ? true
                : false,
            unit_type_case:
              data.unit_type === "Case" || data.unit_type === "Unit / Case"
                ? true
                : false,
            item_type:
              data.weight_type === "r/w"
                ? "catch_weight"
                : data.weight_type === "fix"
                  ? "fixed_random_weight"
                  : "",
            price_per_unit:
              data.case_price && data.units_per_case
                ? (data.case_price / data.units_per_case).toFixed(2)
                : 0,
            unit_price: data.unit_price || 0,
            case_price: data.case_price || 0,
            volume_level: data.volume_level || 0,
            volume_price: data.volume_price || 0,
            average_unit_price: calcAverageUnitPrice,
            average_case_price: calcAverageCasePrice,
            catch_weight: data.catch_weight || false,
            fixed_random_weight: data.fixed_random_weight || false,
            enable_price_links: data.enable_price_links,
          };

          // OFDV = Overridden Fields Default Value
          let productObjOFDV = {};

          overriddenFields.forEach((fItem) => {
            if (
              productObj.overridden_fields_original_values.hasOwnProperty(fItem)
            ) {
              productObjOFDV[fItem] =
                productObj.overridden_fields_original_values[fItem];
            } else {
              productObjOFDV[fItem] = productObj.hasOwnProperty(fItem)
                ? productObj[fItem]
                : null;
            }
          });

          const [surchargeUpc1Detail, surchargeUpc2Detail] = await Promise.all([
            data.surcharge_upc1
              ? backend
                  .get(
                    `${API_URL}products?no_page=1&search=${data.surcharge_upc1}`,
                  )
                  .then(
                    ({ data: d }) =>
                      d.find(
                        (p) => String(p.upc) === String(data.surcharge_upc1),
                      ) || null,
                  )
              : Promise.resolve(null),
            data.surcharge_upc2
              ? backend
                  .get(
                    `${API_URL}products?no_page=1&search=${data.surcharge_upc2}`,
                  )
                  .then(
                    ({ data: d }) =>
                      d.find(
                        (p) => String(p.upc) === String(data.surcharge_upc2),
                      ) || null,
                  )
              : Promise.resolve(null),
          ]);

          setProduct({
            ...productObj,
            surcharge_upc1_detail: surchargeUpc1Detail,
            surcharge_upc2_detail: surchargeUpc2Detail,
            of_default_values: productObjOFDV,
          });
          setProductASOptions(data.acceptable_substitutions_detail);
          setProductLoaded(true);
        });
    };

    if (!isNaN(productId) && !productLoaded) {
      getProduct();
    }
  }, [productId, productLoaded, overriddenFields]);

  useEffect(() => {
    const getProductOptions = async () => {
      console.log("fetching", productASInputValue);
      setIsLoading(true);

      const baseURL = Boolean(productInputValue)
        ? `${API_URL}products?no_page=1&warehouse=2&search=${productInputValue}`
        : `${API_URL}products?no_page=1&search=${productASInputValue}`;

      await backend.get(baseURL).then(({ data }) => {
        if (Boolean(productInputValue)) {
          setProductOptions(data);
        } else {
          const productASUpcList = product.acceptable_substitutions_detail.map(
            (item) => item.upc,
          );

          const dataMap = data.filter(
            (item) =>
              !productASUpcList.includes(item.upc) && item.upc !== product.upc,
          );

          setProductASOptions([
            ...product.acceptable_substitutions_detail,
            ...dataMap,
          ]);
        }
        setIsLoading(false);
      });
    };

    if (productInputValue.length >= 3 || productASInputValue.length >= 3) {
      getProductOptions();
    }
  }, [product, productInputValue, productASInputValue]);

  useEffect(() => {
    if (surchargeUpc1InputValue.length < 3) return;
    setIsSurchargeUpc1Loading(true);
    backend
      .get(`${API_URL}products?no_page=1&search=${surchargeUpc1InputValue}`)
      .then(({ data }) => {
        setSurchargeUpc1Options(data);
        setIsSurchargeUpc1Loading(false);
      });
  }, [surchargeUpc1InputValue]);

  useEffect(() => {
    if (surchargeUpc2InputValue.length < 3) return;
    setIsSurchargeUpc2Loading(true);
    backend
      .get(`${API_URL}products?no_page=1&search=${surchargeUpc2InputValue}`)
      .then(({ data }) => {
        setSurchargeUpc2Options(data);
        setIsSurchargeUpc2Loading(false);
      });
  }, [surchargeUpc2InputValue]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (dirtyFlag) {
        // Cancel the event and show the default browser prompt
        e.preventDefault();
        e.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [dirtyFlag]);

  return (
    <>
      <Container>
        <Modal open={confirmModal} onClose={toggleConfirmModal}>
          {confirmModalContent}
        </Modal>
        <Modal open={deleteConfirmModal} onClose={toggleDeleteConfirmModal}>
          {deleteConfirmModalContent}
        </Modal>
        <Modal open={productModal} onClose={handleCloseProductModal}>
          {productModalContent}
        </Modal>
        {productId && (
          <Stack direction="row" spacing={1} justifyContent="center">
            <Button variant="contained" color="primary">
              <Typography variant="subtitle2" className="text-white">
                Product
              </Typography>
            </Button>
            <Link to={`/product/${productId}/fees`}>
              <Button variant="contained" color="inherit">
                <Typography variant="subtitle2" color="black">
                  Fees
                </Typography>
              </Button>
            </Link>
          </Stack>
        )}
        <br />
        <Typography component="h6" variant="h6" align="center">
          {`${productId ? "Edit" : "Add"} ${product.name || ""}`}
        </Typography>
        <ProductForm
          {...props}
          product={product}
          warehouses={warehouses}
          categories={flattenedCategories}
          handleChange={handleChange}
          overriddenEndorment={overriddenEndorment}
          overriddenStyle={overriddenStyle}
          toggleProductModal={toggleProductModal}
          productId={productId}
          handleCdnUpload={handleCdnUpload}
          handleCdnRemove={handleCdnRemove}
        />
        <br />
        <Typography component="h4" align="center">
          Key Attributes
        </Typography>
        <ProductKeyForm
          {...props}
          product={product}
          handleChange={handleChange}
          overriddenEndorment={overriddenEndorment}
          overriddenStyle={overriddenStyle}
          productASOptions={productASOptions}
          isLoading={isLoading}
          handleChangeProductASInput={handleChangeProductASInput}
        />
        <br />
        <Typography component="h4" align="center">
          More Attributes
        </Typography>
        <ProductMoreForm
          {...props}
          product={product}
          handleChange={handleChange}
          overriddenEndorment={overriddenEndorment}
          overriddenStyle={overriddenStyle}
          surchargeUpc1Options={surchargeUpc1Options}
          isSurchargeUpc1Loading={isSurchargeUpc1Loading}
          handleChangeSurchargeUpc1Input={handleChangeSurchargeUpc1Input}
          surchargeUpc2Options={surchargeUpc2Options}
          isSurchargeUpc2Loading={isSurchargeUpc2Loading}
          handleChangeSurchargeUpc2Input={handleChangeSurchargeUpc2Input}
        />
        <br />
        <Stack direction="row" spacing={1} justifyContent="right">
          <Button onClick={handleBack}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => toggleConfirmModal()}
          >
            Save
          </Button>
        </Stack>
      </Container>
    </>
  );
};

export default ProductAdd;
